import { AgentInfo } from "@/model/data/agent/AgentInfo";
import { OsTypeEnum } from "@/model/data/enums/OsTypeEnum";
import { Branch } from "./Branch";
import { HierarchyPath } from "./HierarchyPath";
import { InstallationPeripheral } from "./InstallationPeripheral";
import { InstalledSoftware } from "./InstalledSoftware";
import { InstallationLicenseData } from "./License/InstallationLicenseData";
import { Machine } from "./Machine";
import { Tag } from "./Tag";
import { InstallationTypeEnum } from "./enums/InstallationTypeEnum";
import { ServiceModeStatusEnum } from "./serviceMode/ServiceModeStatusEnum";
import { ConnectivityStatusEnum } from "./status/ConnectivityStatusEnum";
import { InstallationStatusEnum } from "./status/InstallationStatusEnum";

export class Installation {
    name: string = "";
    installationType: InstallationTypeEnum = InstallationTypeEnum.Unknown;
    branch: Branch = null;
    connectedPc: string = null;
    status: InstallationStatusEnum = InstallationStatusEnum.Unknown;
    connectivityStatus: ConnectivityStatusEnum = ConnectivityStatusEnum.Unknown;
    serviceModeStatus: ServiceModeStatusEnum = ServiceModeStatusEnum.Disabled;
    machines: Machine[] = [];
    peripherals: InstallationPeripheral[] = [];
    installedSoftwares: InstalledSoftware[] = []; // Da ignorare quando chiedo lo stato degli aggiornamenti
    lastMessage: Date = null;
    lastMessageReceivedAt: Date = null;
    licenseData: InstallationLicenseData = null;
    osType: OsTypeEnum = OsTypeEnum.Unknown;
    parentFolder: HierarchyPath = null;
    tags: Tag[] = [];
    agentInfo: AgentInfo = null;
    isThirdParty: boolean = false;

    public parse(obj: any) {
        if (obj.Name) this.name = obj.Name;

        if (obj.InstallationType != null && Object.values(InstallationTypeEnum).includes(obj.InstallationType)) this.installationType = obj.InstallationType;

        if (obj.Branch) {
            this.branch = new Branch();
            this.branch.parse(obj.Branch);
        }

        this.isThirdParty = obj.IsThirdParty;

        if (obj.ConnectedPC) this.connectedPc = obj.ConnectedPC;

        if (obj.Status != null && Object.values(InstallationStatusEnum).includes(obj.Status)) this.status = obj.Status;

        if (obj.ConnectivityStatus != null && Object.values(ConnectivityStatusEnum).includes(obj.ConnectivityStatus)) this.connectivityStatus = obj.ConnectivityStatus;

        if (obj.ServiceModeStatus != null && Object.values(ServiceModeStatusEnum).includes(obj.ServiceModeStatus)) this.serviceModeStatus = obj.ServiceModeStatus;

        if (obj.AgentInfo) {
            this.agentInfo = new AgentInfo();
            this.agentInfo.parse(obj.AgentInfo);
        }

        if (obj.Machines && obj.Machines.length > 0) {
            obj.Machines.forEach((e) => {
                let m: Machine = new Machine();
                m.parse(e);
                this.machines.push(m);
            });
        }

        if (obj.Peripherals && obj.Peripherals.length > 0) {
            obj.Peripherals.forEach((e) => {
                let m: InstallationPeripheral = new InstallationPeripheral();
                m.parse(e);
                this.peripherals.push(m);
            });
        }

        if (obj.InstalledSoftwares && obj.InstalledSoftwares.length > 0) {
            obj.InstalledSoftwares.forEach((e) => {
                let m: InstalledSoftware = new InstalledSoftware();
                m.parse(e);
                this.installedSoftwares.push(m);
            });
        }

        if (obj.LastMessage) this.lastMessage = obj.LastMessage;

        if (obj.LastMessageReceivedAt) this.lastMessageReceivedAt = obj.LastMessageReceivedAt;

        if (obj.LicenseData) {
            this.licenseData = new InstallationLicenseData();
            this.licenseData.parse(obj.LicenseData);
        }

        if (obj.OsType != null && Object.values(OsTypeEnum).includes(obj.OsType)) this.osType = obj.OsType;

        if (obj.ParentFolder) {
            this.parentFolder = new HierarchyPath();
            this.parentFolder.parse(obj.ParentFolder);
        }

        if (obj.Tags && obj.Tags.length > 0) {
            obj.Tags.forEach((e) => {
                let t: Tag = new Tag();
                t.parse(e);
                this.tags.push(t);
            });
        }
    }
}
